<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-clipboard-list" texto-titulo="Editar familia"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarFamilia()">
          <float-label label="Descripción:" clase>
            <input
              v-model="familia.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.familia.descripcion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.familia.descripcion.required"
              >Debe ingresar una descripción</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required } from 'vuelidate/lib/validators';
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Familia from "@/models/familia";
export default {
  name: "NuevaFamilia",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel
  },
  data() {
    return {
      familia: new Familia(null, ""),
      loading: false,
      enviado:false
    };
  },
  validations:{
    familia:{
      descripcion:{required},
    }
  },
  mounted() {
    this.familia.id = this.$route.params.id;
    this.getFamilia();
  },
  methods: {
    getFamilia() {
      this.loading = true;
      axios
        .get("familias/" + this.familia.id)
        .then(res => {
          if (res.data.success) {
            this.familia = res.data.familia;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado familia.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarFamilia() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/familias/" + this.familia.id, this.familia)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.familia.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarFamilias" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>